export default {
  getTimeList() {
    return [
      { label: "Midnight", value: "00:00" },
      { label: "1:00 AM", value: "01:00" },
      { label: "2:00 AM", value: "02:00" },
      { label: "3:00 AM", value: "03:00" },
      { label: "4:00 AM", value: "04:00" },
      { label: "5:00 AM", value: "05:00" },
      { label: "6:00 AM", value: "06:00" },
      { label: "7:00 AM", value: "07:00" },
      { label: "8:00 AM", value: "08:00" },
      { label: "9:00 AM", value: "09:00" },
      { label: "10:00 AM", value: "10:00" },
      { label: "11:00 AM", value: "11:00" },
      { label: "Noon", value: "12:00" },
      { label: "1:00 PM", value: "13:00" },
      { label: "2:00 PM", value: "14:00" },
      { label: "3:00 PM", value: "15:00" },
      { label: "4:00 PM", value: "16:00" },
      { label: "5:00 PM", value: "17:00" },
      { label: "6:00 PM", value: "18:00" },
      { label: "7:00 PM", value: "19:00" },
      { label: "8:00 PM", value: "20:00" },
      { label: "9:00 PM", value: "21:00" },
      { label: "10:00 PM", value: "22:00" },
      { label: "11:00 PM", value: "23:00" }
    ];
  },

  getTimeListAsObject() {
    let timeList = {};
    this.getTimeList().map(item => {
      timeList[item.value] = item.label;
    });
    return timeList;
  },

  getDayOfWeekList() {
    return [
      { label: "Sunday", value: 0 },
      { label: "Monday", value: 1 },
      { label: "Tuesday", value: 2 },
      { label: "Wednesday", value: 3 },
      { label: "Thursday", value: 4 },
      { label: "Friday", value: 5 },
      { label: "Saturday", value: 6 }
    ];
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/DateTimeUtil.js